<div class="displayInline sort_selector_component_main" [ngClass]="{'mobile': screenWidth < 1024}">
  <span class="displayInline sort_selector_label" [ngClass]="{'mobile': screenWidth < 1024}" >{{'RESULTS.sortby' | translate}} : </span>
    <div class="displayInline sort-selector-container" [ngClass]="{'mobile': screenWidth < 1024}">
          <div class="input-sort-selector"
               [clickOutsideEnabled]="true" [excludeBeforeClick]="true" (clickOutside)="hideAndRestoreLabel()">
            <input
              #searchSortFieldBox
              (keyup)="onKeyUp(searchSortFieldBox.value)"
              (keydown)="onKeyDown($event)"
              (focus)="onFocus()"
              (click)="onclick()"
              placeholder="{{'RESULTS.SORT_CHOICE.search' | translate}}"
              [value]="selectedSortLabel"
            />
            <button class="combo-btn openOptions" (click)="selectedSortLabel.length > 0 && selectedSortLabel !== defaultSearchItem.keyword ? removeValue() : toogleOptionsList()">
              <mat-icon fontSet="material-icons-outlined">
                <ng-container *ngIf="selectedSortLabel.length > 0 && selectedSortLabel !== defaultSearchItem.keyword; else toogleTemplate">
                  {{'remove_circle_outline'}}
                </ng-container>
              </mat-icon>
            </button>
            <div class="combo-sort-selector" *ngIf="focusOn"
                 perfectScrollbar>
              <h5 (click)="hideAndRestoreLabel()">
                {{(noResults ? 'RESULTS.SORT_CHOICE.searchForField' : 'RESULTS.SORT_CHOICE.choosefield') | translate}}
              </h5>
              <ul *ngIf=" itemsContent.length > 0" class="{{AUTOCOMPLETE_ITEMS_CONTAINER_CLASS}}">
                <li
                  tabindex="{{i}}"
                  class="listSortSelector-item"
                  *ngFor="let item of itemsContent; let i = index"
                  (mouseover)="setSelectedItem(i)"
                  (keydown)="keyDownOnListEvent($event, i, item, false)"
                  [class.selected]="i == selectedItem"
                  (click) = "addItem(item)">
                  <span *ngIf="isEntityField(item)"
                        class="entityBar"
                        [style.background-color]="getEntityTypeColor(item)"
                        appTooltip="{{'ENTITIES.SEARCH.aggItem' | translate: {entityType: ('entity_type' | nxI18n:getEntityType(item):'singular')} }}"
                        placement="top"></span>
                  <span>{{item.keyword}}</span>
                </li>
              </ul>
            </div>
          </div>
  </div>
  <div class="displayInline sortDirectionSelectorContainer" [ngClass]="{'mobile': screenWidth < 1024}"  *ngIf="selectedSortKey && selectedSortKey !==''">
    <ng-container *ngIf="screenWidth < 1024">
      <span class="sortDirectionLabel">{{ 'RESULTS.SORT_DIRECTION.LABEL' | translate }} : </span>
    </ng-container>

    <app-autocomplete
      class="autocompleteSortBySelector"
      [inputChange]="searchBy"
      [showRemoveBtn]="false"
      [optionKeyForLabel]="'sortLabel'"
      [defaultValue]="getSortDirectionDefaultValue()"
      (onSelectItem)="onSortDirectionChangeAutoComplete($event)"
    ></app-autocomplete>

  </div>
</div>

<ng-template #toogleTemplate>
  {{focusOn ? 'expand_less': 'expand_more'}}
</ng-template>
